<template>
  <v-container fluid class="pa-0">
    <v-card
      class="maintenance-banner"
      @click="redirectToPackages"
      role="link"
      aria-label="Explore home maintenance packages"
      elevation="0"
    >
      <div class="animated-bg"></div>
      <v-row no-gutters align="center" class="banner-content">
        <v-col cols="12" md="7" class="pa-5 pa-md-8">
          <div class="content-wrapper">
            <div class="title-wrapper mb-2">
              <h2 class="banner-title">
                Professional Home
                <span class="accent-text">Maintenance</span>
                Packages
              </h2>
              <div class="title-decoration"></div>
            </div>

            <p class="banner-subtitle mb-4">
              Keep your home in perfect condition with our comprehensive
              maintenance solutions. Choose from flexible packages tailored to
              your needs.
            </p>

            <div class="features-grid mb-4">
              <div
                class="feature-item"
                v-for="(feature, index) in features"
                :key="index"
              >
                <div class="feature-icon-wrapper">
                  <v-icon color="#22DD22" small>
                    {{ feature.icon }}
                  </v-icon>
                </div>
                <span class="feature-text">{{ feature.text }}</span>
              </div>
            </div>

            <div class="actions-row">
              <v-btn
                large
                :color="accent"
                class="explore-btn"
                elevation="3"
                dark
                @click.stop="redirectToPackages"
                aria-label="Explore packages"
              >
                Explore Packages
                <v-icon right small>mdi-arrow-right</v-icon>
              </v-btn>

             
            </div>
          </div>
        </v-col>

        <v-col cols="12" md="5" class="pa-0 d-none d-md-block">
          <div class="visual-section">
            <div class="cards-stack">
              <div
                class="package-card"
                v-for="(pkg, index) in packages"
                :key="index"
              >
                <div class="icon-wrapper">
                  <v-icon :color="accent" size="28">
                    {{ pkg.icon }}
                  </v-icon>
                </div>
                <div class="card-content">
                  <div class="card-title">{{ pkg.title }}</div>
                  <div class="card-subtitle">{{ pkg.subtitle }}</div>
                </div>
              </div>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: "HomeMaintenanceBanner",
  data() {
    return {
      accent: "#FF6B35",
      features: [
        { icon: "mdi-check-circle", text: "Regular Inspections" },
        { icon: "mdi-check-circle", text: "Priority Support" },
        { icon: "mdi-check-circle", text: "Expert Technicians" },
        { icon: "mdi-check-circle", text: "Flexible Scheduling" },
      ],
      packages: [
        {
          icon: "mdi-home-outline",
          title: "Silver Package",
          subtitle: "Essential home care services",
          featured: false,
        },
        {
          icon: "mdi-home-heart",
          title: "Gold Package",
          subtitle: "Complete protection & maintenance",
          featured: true,
        },
        {
          icon: "mdi-shield-home",
          title: "Platinum Package",
          subtitle: "Ultimate service experience",
          featured: false,
        },
      ],
    };
  },

  methods: {
    redirectToPackages() {
      window.open("https://homemaintenance.ohyesworld.com/", "_blank");
    },
    openLearnMore() {
      window.open("https://homemaintenance.ohyesworld.com/#packages", "_blank");
    },
  },
};
</script>

<style scoped>
.maintenance-banner {
  position: relative;
  min-height: 380px;
  overflow: hidden;
  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  border: 1px solid #e8eaed;
}

.animated-bg {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: radial-gradient(
      circle at 20% 50%,
      rgba(255, 107, 53, 0.03) 0%,
      transparent 50%
    ),
    radial-gradient(
      circle at 80% 50%,
      rgba(255, 107, 53, 0.02) 0%,
      transparent 50%
    );
  pointer-events: none;
  z-index: 0;
}

@media (min-width: 1600px) {
  .maintenance-banner {
    max-width: 1900px;
    margin: 0 auto;
  }
}

.maintenance-banner:hover {
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.1);
  transform: translateY(-2px);
  border-color: rgba(255, 107, 53, 0.2);
}

.banner-content {
  position: relative;
  z-index: 1;
}

.content-wrapper {
  max-width: 580px;
}

@media (min-width: 1280px) {
  .content-wrapper {
    padding-left: 100px;
  }
}

@media (min-width: 1600px) {
  .content-wrapper {
    padding-left: 0;
  }
}

.title-wrapper {
  position: relative;
  display: inline-block;
}

.banner-title {
  font-size: 2.1rem;
  font-weight: 800;
  line-height: 1.25;
  color: #1a202c;
  margin: 0;
  letter-spacing: -0.5px;
}

.accent-text {
  color: #ff6b35;
  display: inline;
  position: relative;
  background: linear-gradient(120deg, #ff6b35 0%, #ff8c5a 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.title-decoration {
  position: absolute;
  bottom: -4px;
  left: 0;
  width: 60px;
  height: 3px;
  background: linear-gradient(90deg, #ff6b35 0%, transparent 100%);
  border-radius: 2px;
}

.banner-subtitle {
  font-size: 0.975rem;
  line-height: 1.65;
  color: #4a5568;
  margin: 0;
  font-weight: 400;
}

.features-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;
}

.feature-item {
  display: flex;
  align-items: center;
  font-size: 0.9rem;
  font-weight: 500;
  color: #2d3748;
  padding: 10px 14px;
  background: linear-gradient(135deg, #ffffff 0%, #f7fafc 100%);
  border-radius: 8px;
  border: 1px solid #e2e8f0;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
}

.feature-item::before {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 107, 53, 0.05),
    transparent
  );
  transition: left 0.5s ease;
}

.feature-item:hover::before {
  left: 100%;
}

.feature-item:hover {
  background: #ffffff;
  border-color: rgba(255, 107, 53, 0.3);
  transform: translateX(4px);
  box-shadow: 0 2px 8px rgba(255, 107, 53, 0.1);
}

.feature-icon-wrapper {
  display: flex;
  align-items: center;
  margin-right: 8px;
}

.feature-text {
  color: #2d3748;
}

.actions-row {
  display: flex;
  align-items: center;
  gap: 12px;
}

.explore-btn {
  font-weight: 600;
  letter-spacing: 0.3px;
  text-transform: none;
  font-size: 0.975rem;
  border-radius: 8px !important;
  padding: 0 32px !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
  background: linear-gradient(135deg, #ff6b35 0%, #ff7a45 100%) !important;
}

.explore-btn:hover {
  transform: translateY(-3px);
  box-shadow: 0 8px 20px rgba(255, 107, 53, 0.35) !important;
}

.explore-btn:active {
  transform: translateY(-1px);
}

.learn-btn {
  font-weight: 500;
  color: #2d3748;
  text-transform: none;
  transition: all 0.3s ease;
  border-radius: 8px;
}

.learn-btn:hover {
  background: rgba(255, 107, 53, 0.08) !important;
  color: #ff6b35;
}

.visual-section {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 30px;
  background: linear-gradient(135deg, #f8f9fa 0%, #f1f3f5 100%);
  border-left: 1px solid #e8eaed;
  position: relative;
}

.visual-section::before {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 300px;
  height: 300px;
  background: radial-gradient(
    circle,
    rgba(255, 107, 53, 0.05) 0%,
    transparent 70%
  );
  border-radius: 50%;
  pointer-events: none;
}

.cards-stack {
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
  max-width: 270px;
  position: relative;
  z-index: 1;
}

.package-card {
  background: #ffffff;
  border-radius: 10px;
  padding: 16px 18px;
  display: flex;
  align-items: center;
  gap: 12px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  border: 1px solid #e8eaed;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  opacity: 0;
  animation: slideInRight 0.6s ease forwards;
  position: relative;
}

@keyframes slideInRight {
  from {
    opacity: 0;
    transform: translateX(20px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

.package-card:hover {
  transform: translateX(-10px) scale(1.02);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.12);
  border-color: #cbd5e0;
}

.featured-card {
  border: 2px solid #ff6b35;
  box-shadow: 0 4px 16px rgba(255, 107, 53, 0.15);
  background: linear-gradient(135deg, #ffffff 0%, #fff5f0 100%);
}

.featured-card:hover {
  box-shadow: 0 8px 24px rgba(255, 107, 53, 0.25);
  transform: translateX(-10px) scale(1.05);
}

.icon-wrapper {
  background: linear-gradient(135deg, #f7fafc 0%, #edf2f7 100%);
  border-radius: 10px;
  width: 52px;
  height: 52px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  flex-shrink: 0;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.04);
}

.package-card:hover .icon-wrapper {
  background: linear-gradient(135deg, #edf2f7 0%, #e2e8f0 100%);
  transform: scale(1.1) rotate(5deg);
}

.featured-card .icon-wrapper {
  background: linear-gradient(135deg, #fff5f0 0%, #ffe8db 100%);
}

.card-content {
  flex: 1;
}

.card-title {
  font-weight: 700;
  font-size: 0.975rem;
  color: #1a202c;
  margin-bottom: 2px;
  letter-spacing: -0.2px;
}

.card-subtitle {
  font-size: 0.825rem;
  color: #718096;
  line-height: 1.4;
  font-weight: 400;
}

.featured-badge {
  position: absolute;
  top: 8px;
  right: 8px;
  animation: pulse 2s ease-in-out infinite;
}

@keyframes pulse {
  0%,
  100% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(1.1);
    opacity: 0.8;
  }
}

@media (max-width: 960px) {
  .visual-section {
    display: none;
  }
  .banner-title {
    font-size: 1.65rem;
  }
  .banner-subtitle {
    font-size: 0.925rem;
  }
  .features-grid {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 600px) {
  .maintenance-banner {
    min-height: 350px;
  }
  .banner-title {
    font-size: 1.45rem;
  }
  .explore-btn {
    width: 100%;
  }
  .actions-row {
    flex-direction: column;
    gap: 8px;
    align-items: stretch;
  }
  .learn-btn {
    width: 100%;
  }
  .feature-item {
    padding: 9px 12px;
    font-size: 0.875rem;
  }
}
</style>
